<template>
  <custom-dialog width="50%" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body organ-device-dialog">
      <div class="bind">
        <div class="ub" style="padding: 0 8px 16px">
          <div class="left-box ub-f1">
            <div class="tit">{{ $t('crm_partner_contactsBatch_dialog.qing_xuan_ze_bu_men') }}/{{ $t('crm_partner_contactsBatch_dialog.yuan_gong') }}</div>
            <div class="tree-box">
              <div class="tree">
                <el-tree
                  ref="tree"
                  show-checkbox
                  node-key="frontUnique"
                  :data="organTree"
                  :props="{
                    children: 'children',
                    label: 'bizName',
                    disabled: setDisabled
                  }"
                  @check="checkChange"
                  :expand-on-click-node="false"
                  :default-expanded-keys="expandedKeys"
                  highlight-current
                >
                  <span class="tree-item" slot-scope="{ node, data }">
                    <i style="color: #F7B500" v-if="data.bizType === 3" class="icon icon-yonghu1"></i>
                    <i style="color: #00AFFF" v-else class="icon icon-zuzhi1"></i>
                    <span>{{ node.label }}</span>
                  </span>
                </el-tree>
              </div>
            </div>
          </div>
          <div class="right-box ub-f1">
            <div class="tit">{{ $t('crm_partner_contactsBatch_dialog.yi_xuan_de_bu_men') }}/{{ $t('crm_partner_contactsBatch_dialog.yuan_gong') }}</div>
            <div class="tree-box">
              <div class="tree" v-show="show">

                <el-tree
                  ref="tree1"
                  node-key="frontUnique"
                  :data="organTree"
                  :props="{ children: 'children', label: 'bizName' }"
                  :expand-on-click-node="false"
                  :default-expanded-keys="expandedKeys"
                  :filter-node-method="filterCheckNode"
                  highlight-current
                >
                  <span class="tree-item" slot-scope="{ node, data }">
                    <i style="color: #F7B500" v-if="data.bizType === 3" class="icon icon-yonghu1"></i>
                    <i style="color: #00AFFF" v-else class="icon icon-zuzhi1"></i>
                    <span>{{ node.label }}</span>
                  </span>
                </el-tree>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="saveUpdate">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      // item: {},
      organTree: [],
      expandedKeys: [],
      organUser: [],
      show: false,
      checkedKeys: [],
      checkedNodes: [],
      partnerId: '',
      partnerOrgId: '',
      bizObjects: []
    };
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 禁用状态
    setDisabled(data) {
      const list = data.children || [];
      return list.find(t => this.checkedKeys.includes(t.bizId));
    },
    // 初始化
    initDialog: function () {
      this.getOrganTree();
      // this.item = this.model.data;
      // 清空重置值
      this.partnerId = this.model.partnerId;
      this.partnerOrgId = this.model.partnerOrgId;
    },
    // 获取组织
    getOrganTree: function () {
      this.$getJSON(apis.OrganDepartmentTree, {
        isShowUsers: 1,
        // orgId: this.model.data.orgId
      }).then((res) => {
        this.expandedKeys = [res.data.frontUnique];
        this.organTree = [res.data];
        this.$nextTick(() => {
          this.setSelected();
          // this.getDeviceOrgUser();
          // this.$refs.tree1.filter();
          // this.show = true;
        });
      });
    },


    // 清空已选择人
    setSelected: function () {
      this.$refs.tree1.filter([]);
      this.$nextTick(() => {
        this.show = true;
      });
    },
    // 选中转换树
    checkChange: function () {
      if (!this.organUser || !this.organUser.length) {
        this.organUser = this.organTree;
      }
      this.$nextTick(() => {
        const selectNodes = this.$refs.tree.getCheckedNodes();
        this.$refs.tree1.filter(selectNodes);
      });
    },
    // 选中树过滤
    filterCheckNode(nodes, data) {
      // console.log(nodes, data);
      // return false;
      return !!nodes.find(t => t.frontUnique === data.frontUnique);
    },
    // 调用方法来处理多层数组
    processNodes(nodes) {
      const userIdSet = new Set();
      const uniqueBizObjects = [];

      function processNode(node) {
        if (node.bizType === 3 && node.userId !== undefined) {
          if (!userIdSet.has(node.userId)) {
            const processedNode = {
              contactName: node.bizName,
              mobilePhone: node.mobile,
              email: node.email,
              post: this.$t('crm_partner_contactsBatch_dialog.ye_wu_fu_ze_ren'),
              contactType: 'coopcontact', // 联系负责人
              userId: node.userId
            };
            uniqueBizObjects.push(processedNode);
            userIdSet.add(node.userId);
          }
        }

        if (node.children && node.children.length > 0) {
          node.children.forEach((child) => {
            processNode.call(this, child); // 递归处理子节点
          });
        }
      }

      nodes.forEach((node) => {
        processNode.call(this, node); // 处理根节点
      });

      this.bizObjects = uniqueBizObjects;
    },

    saveUpdate: function () {
      this.bizObjects = [];
      const selectNodes = this.$refs.tree.getCheckedNodes();
      this.processNodes(selectNodes);
      this.$postJSON(
        apis.partnerContactBatchAdd,
        {
          partnerCoopcontacts: this.bizObjects,
          partnerId: this.model.partnerId,
          partnerOrgId: this.model.partnerOrgId
        },
        true
      ).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success'
        });
        this.$emit('success');
        this.visible = false;
      });
    }
  }
};
</script>

<style lang="scss">
.organ-device-dialog {
  .title {
    color: #262626;
    font-size: 16px;
    line-height: 24px;
    padding-left: 10px;
    position: relative;
    .bar {
      left: 0;
      width: 4px;
      height: 15px;
      background: rgba(0, 175, 255, 1);
    }
  }
  .info {
    padding: 0 16px 16px;
    .item {
      font-size: 12px;
      color: #262626;
      line-height: 24px;
      span {
        color: #6e6e6e;
      }
    }
  }
  .tit {
    line-height: 40px;
    color: #262626;
    font-weight: bold;
    font-size: 13px;
    padding-left: 10px;
  }
  .left-box {
    display: flex;
    flex-direction: column;
    margin-right: 5px;
  }
  .right-box {
    display: flex;
    flex-direction: column;
    margin-left: 5px;
  }
  .tree-box {
    padding: 8px 11px;
    border: 1px solid #e4e4e4;
    height: 480px;
    overflow-y: auto;
  }
  .tree {
    height: 100%;
    overflow-y: auto;
    .tree-item {
      flex: 1;
      display: flex;
      align-items: center;
      font-size: 12px;
      padding-right: 8px;
      .icon {
        margin-right: 4px;
        font-size: 15px;
      }
      .el-checkbox__label {
        font-size: 12px;
      }
    }
  }
}
</style>
